import * as React from 'react'
import styled from 'styled-components'
import { media } from '../../../utils'

interface Props {
  title: string
  onClick: (title) => void
  checked?: boolean
}

const circleIcon = require('src/assets/wizard/circle_blue.png')
const checkedIcon = require('src/assets/wizard/checkmark_white.png')

export const ChecklistItem = (props: Props) => {
  const { checked, title, onClick } = props
  return (
    <StyledChecklistItem checked={checked} onClick={onClick}>
      {title}
      <img alt='checked' src={checked ? checkedIcon : circleIcon} />
    </StyledChecklistItem>
  )
}

const StyledChecklistItem = styled.p`
  position: relative;
  margin: 15px 0 7.5px 0;
  padding: 7.5px;
  padding-right: 30px;
  border: 2px solid #a7c9cd;
  cursor: pointer;
  background-color: white;
  transition: background-color 0.2s ease;
  will-change: background-color;

  ${(props) =>
    props.checked &&
    `
      background-color: #a7c9cd;
      color: white;
    `}

  & > img {
    position: absolute;
    top: 50%;
    right: 0;
    width: 25px;
    transform: translate(-50%, -50%);
    ${media.tablet` width: 20px; `}
  }
`

export default ChecklistItem



// WEBPACK FOOTER //
// ./src/components/atoms/input/Checklist.tsx